export default __webpack_public_path__ + "static/media/BB_36.3b4b122e.png";